import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose, withState, withProps } from 'recompose'
import Dropzone from 'react-dropzone'
import uuid from 'uuid'

import { createErrorToasterMessage } from 'data/ui/actions'
import { uploadFile } from 'data/medias/actions'
import { FileUploadRecord } from 'data/medias/record'
import { getFileUpload } from 'data/medias/selectors'
import { FILE_ACCEPTED_TYPES, MAX_FILE_SIZE } from 'data/medias/record'

import { logger } from 'logger'

class FileUpload extends Component {
  static propTypes = {
    accept: PropTypes.string,
    renderContent: PropTypes.func.isRequired,
    uploadFile: PropTypes.func.isRequired,
    onUploadSuccess: PropTypes.func.isRequired,
    onUploadError: PropTypes.func.isRequired,
    resetUUID: PropTypes.func.isRequired,
    uuid: PropTypes.string.isRequired,
    fileUpload: PropTypes.object,
    maxSize: PropTypes.number.isRequired,
    className: PropTypes.string.isRequired,
    multiple: PropTypes.bool,
  }

  static defaultProps = {
    accept: FILE_ACCEPTED_TYPES,
    maxSize: MAX_FILE_SIZE,
    className: 'width-full',
    renderContent({ fileUpload, uuid }) {
      return (
        <pre>
          {uuid}
          {JSON.stringify(fileUpload, null, 2)}
        </pre>
      )
    },
    onUploadSuccess(data) {
      logger.debug('File Upload', 'success', data.url)
    },
    onUploadError(error) {
      throw error
    },
  }

  componentDidMount() {
    this.props.resetUUID()
  }

  componentWillReceiveProps(newProps) {
    const previousFileUpload = this.props.fileUpload || new FileUploadRecord()
    const newFileUpload = newProps.fileUpload || new FileUploadRecord()
    if (previousFileUpload.uploading && !newFileUpload.uploading) {
      this.props.onUploadSuccess(newFileUpload.toJS())
    }
    if (!previousFileUpload.error && newFileUpload.error) {
      this.props.onUploadError(newFileUpload.error)
    }
  }

  render() {
    const {
      uuid,
      fileUpload,
      uploadFile,
      renderContent,
      className,
      accept,
      onClick,
      onRef,
      multiple = false,
    } = this.props
    const dropzoneProps = {
      accept,
      className,
      onClick,
    }

    return (
      <Dropzone
        {...dropzoneProps}
        multiple={multiple}
        ref={onRef}
        onDropAccepted={files => uploadFile({ uuid, files })}
      >
        {renderContent({ uuid, fileUpload })}
      </Dropzone>
    )
  }
}

const EnhancedFileUpload = compose(
  withState('uuid', 'setUUID', () => uuid()),
  withProps(({ setUUID, ...props }) => ({
    ...props,
    resetUUID() {
      setUUID(uuid())
    },
  })),
  connect(
    (state, { uuid }) => ({
      fileUpload: getFileUpload(state, uuid),
    }),
    (dispatch, { onUpload }) => ({
      createErrorToasterMessage: data =>
        dispatch(createErrorToasterMessage(data)),
      uploadFile: onUpload ? onUpload : uploadFile,
    })
  )
)(FileUpload)

export default EnhancedFileUpload
